import { TopUpButton } from './TopUpButton';

export function TopUpPanel({ userCoins }) {
  return (
    <div className="flex-shrink-0 flex items-center justify-between gap-1 px-4 py-2 bg-[#010D0D] border-t border-[#0B6666]/30">
      <div className="flex items-center gap-1">
        <span className="text-lg font-medium text-white opacity-50">Счёт:</span>
        <div className="flex items-center gap-1">
          <span className="text-lg font-medium text-white">{userCoins.toFixed(2)}</span>
          <img src="/icons/coin.svg" className="w-[20px] h-[20px]" alt="coin" />
        </div>
      </div>
      <TopUpButton />
    </div>
  );
}
